import {
  Box,
  Card,
  Dialog,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import * as React from 'react';
import { FC, useEffect, useState } from 'react';
import {
  ListProps,
  ShowButton,
  useDataProvider,
  useNotify,
  EditButton,
  usePermissions,
} from 'react-admin';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { getFieldByTitle } from '../../helpers/sortByTitle';
import { Winner } from '../../types/winner';
import PaginationTable from '../common/paginationTable';
import HeadTable from '../common/sortTable/sortTable';
import TablesSearch from '../common/tablesSearch/tablesSearch';

import './index.css';
import { getDateForPicker } from '../../helpers/dateHelper';
import DateFilter from '../users/DateFilter';
import { checkPermission } from '../../helpers/checkPermissions';
import { RemoveEntityModalContent } from '../common/removeEntityPopUp/RemoveEntity';
import WidgetsListTitle from '../common/listTitles/WidgetsListTitle';

const WidgetsList: FC<ListProps> = (props) => {
  const { permissions } = usePermissions();
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const [state, setState] = useState({
    widgets: Array<any>(),
    total: 0,
    page: 1,
    perPage: 10,
    field: '_id',
    order: 'asc',
  });

  const [dropdown, setDropdown] = useState({
    competitionNumber: false,
    competition: false,
    finish: false,
    title: false,
  });
  const [searchState, setSearchState] = useState({
    competitionNumber: '',
    competition: '',
    finishDate: '',
    title: '',
  });
  const [filter, setFilter] = useState({
    blocked: 'all',
    searchField: '',
    startDate: new Date('2000-01-18T19:55:00.000+00:00'),
    endDate: new Date('2030-01-18T19:55:00.000+00:00'),
  });

  const [blockedFilter, setBlockedFilter] = useState({
    with: false,
    without: false,
  });

  const [modal, setModal] = useState({
    showModal: false,
    id: '',
  });

  useEffect(() => {
    getWidgets({});
  }, []);

  const getWidgets = async (fields: any) => {
    const winners = (await dataProvider.getWidgets({})) as any;
    setState({
      ...state,
      widgets: winners.data,
      total: winners.total,
    });
  };

  const applyDateFilter = (): void => {
    getWidgets({});
  };
  const clearDateFilter = (): void => {
    setFilter({
      ...filter,
      startDate: new Date('2000-01-18T19:55:00.000+00:00'),
      endDate: new Date('2030-01-18T19:55:00.000+00:00'),
    });
  };

  const setStartDate = (value: Date): void => {
    setFilter({ ...filter, startDate: value });
  };

  const setEndDate = (value: Date): void => {
    setFilter({ ...filter, endDate: value });
  };
  const filterDropdown = (title: string) => {
    const titleArray = title.toLowerCase().split(' ');
    setDropdown({ ...dropdown, [titleArray[0]]: !dropdown[titleArray[0]] });
  };
  const handleSort = (direction: string, title: string) => {
    let field = getFieldByTitle(title);
    if (field === 'Finish date') {
      field = 'drawDate';
    }
    getWidgets({});
  };
  const handleSortTitle = (direction: string, title: string) => {
    const field = 'name';
    getWidgets({});
  };
  const search = (value: string, field: string) => {
    setSearchState({ ...searchState, [field]: value });
  };
  const applySearch = (field: string) => {
    setFilter({ ...filter, searchField: field });
    getWidgets({});
  };
  const clearSearch = (clear: string) => {
    setSearchState({ ...searchState, [clear]: '' });
  };
  const clearDiscountFilter = () => {
    setBlockedFilter({ with: false, without: false });
    setFilter({ ...filter, blocked: 'all' });
  };

  const closeModal = () => {
    setModal({ ...modal, showModal: false, id: '' });
  };

  const openModal = (id: string) => {
    setModal({ ...modal, showModal: true, id: id });
  };

  const handleLastPage = () => {
    const page = Math.ceil(state.total / state.perPage);
    getWidgets({});
  };

  const handleFirstPage = () => {
    getWidgets({});
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    const perPage = parseInt(event.target.value, 10);
    getWidgets({});
  };

  const applyFilter = (field: string, conditions: Array<string>) => {
    getWidgets({});
  };

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ): void => {
    getWidgets({});
  };

  const removeWinner = async () => {
    try {
      const result = await dataProvider.delete('winners', {
        id: modal.id,
        previousData: {} as Winner,
      });
      if (result.data) {
        closeModal();
        notify(result.data.message, 'info');
        getWidgets({});
      }
    } catch (error) {
      notify('Winner not found', 'error');
    }
  };

  const closeFilter = () => {
    setDropdown({
      competitionNumber: false,
      competition: false,
      finish: false,
      title: false,
    });
  };

  return (
    <>
      <WidgetsListTitle title='Widgets' hideAddButton={false} isShow={false} />
      <Box marginTop='0.5em'>
        <Card>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell id='active-table-head'>
                    Widget Name
                    {/* <HeadTable
                      title='Widget Name'
                      sort={handleSort}
                      filterHandle={filterDropdown}
                    />

                    {dropdown.finish && (
                      <DateFilter
                        applyDateFilter={applyDateFilter}
                        clearDateFilter={clearDateFilter}
                        endDate={filter.endDate}
                        startDate={filter.startDate}
                        setStartDate={setStartDate}
                        setEndDate={setEndDate}
                      />
                    )} */}
                  </TableCell>
                  <TableCell>Widget Status</TableCell>
                  <TableCell id='active-table-head'>
                    Widget Type
                    {/* <HeadTable title='Widget Type' sort={handleSortTitle} />
                    {dropdown.title && (
                      <TablesSearch
                        search={(event) =>
                          search(event.currentTarget.value, 'title')
                        }
                        applySearch={() => applySearch('title')}
                        searchString={searchState.title}
                        clearSearch={() => clearSearch('title')}
                      />
                    )} */}
                  </TableCell>
                  <TableCell id='active-table-head-actions'>Actions</TableCell>
                </TableRow>
              </TableHead>
              {state.widgets.map((item) => {
                return (
                  <TableBody
                    key={item.id}
                    className={item.id === modal.id ? 'mark-user-row' : ''}
                    onClick={closeFilter}
                  >
                    <TableRow>
                      <TableCell>{item.name}</TableCell>
                      <TableCell>
                        {item.active ? 'Active' : 'Disactive'}
                      </TableCell>
                      <TableCell>{item.type}</TableCell>
                      <TableCell>
                        <div className='actions-table-body'>
                          <ShowButton to={`widgets/${item._id}/show`} />
                          <EditButton
                            to={`widgets/${item._id}`}
                            className='edit-prize'
                          />
                          {/* <div onClick={() => openModal('' + item._id!)}>
                            <DeleteForeverIcon className='delete-icon' />
                          </div> */}
                        </div>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                );
              })}
            </Table>
          </TableContainer>
          <Dialog fullWidth open={modal.showModal} onClose={closeModal}>
            <DialogContent>
              <RemoveEntityModalContent
                closeModal={closeModal}
                removeUser={removeWinner}
                entityName={'winner'}
              />
            </DialogContent>
          </Dialog>
        </Card>
      </Box>
    </>
  );
};

export default WidgetsList;
